module.exports = __webpack_public_path__ + "media/fonts/Unica77LLTT-Light-f0e796a84fb1f1a0267baf6c2cf352dd.woff";